// extracted by mini-css-extract-plugin
export var arrow = "bh_9";
export var body = "bh_g";
export var circle = "bh_fb";
export var customer = "bh_d9";
export var feedback = "bh_d8";
export var feedbacks = "bh_d6";
export var footer = "bh_cF";
export var footerText = "bh_cG";
export var left = "bh_bS";
export var nameLocation = "bh_fc";
export var padding = "bh_dD";
export var right = "bh_bV";
export var section = "bh_b";
export var selected = "bh_bg";
export var selectors = "bh_d5";
export var subtitle = "bh_cV";
export var text = "bh_cn";
export var title = "bh_f";
export var wrapper = "bh_d7";